import { Injectable, inject } from '@angular/core';
import { PlayReportingService } from './play-reporting.service';
import { Environment } from '@r1-compass-library/environments/environment';
import { PlayAuditSearch } from '@r1-compass-library/models/search/play-audit-search.model';
import { Observable, catchError, of, retry } from 'rxjs';
import { PlayAudit } from '@r1-compass-library/models';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpHeaderConstants } from '@r1-compass-library/constants/http-header.constants';

@Injectable({
    providedIn: 'root',
})
export class PlayReportingAuditService extends PlayReportingService {
    readonly #http = inject(HttpClient);

    private PLAY_AUDIT_URL = Environment.baseUrl + '/frontend/play-reporting-audits';

    constructor() {
        super();
    }

    getPlayAudits(search: PlayAuditSearch): Observable<PlayAudit[]> {
        const customHttpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders }),
            params: new HttpParams({}),
        };
        this.addSearchParams(search, customHttpOptions);
        return this.#http.get<PlayAudit[]>(this.PLAY_AUDIT_URL, customHttpOptions).pipe(
            retry(0),
            catchError(() => {
                return of<PlayAudit[]>();
            })
        );
    }
}
